import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useUsmAuth } from "@/contexts/UsmAuthContext";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

export default function UsmLogin() {
  const { employee, loading, login } = useUsmAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen bg-[#0A0A0A]" />;
  if (employee) return <Navigate to="/usm" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await login(username.trim().toLowerCase(), password);
      toast.success("Giriş başarılı");
      navigate("/usm", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="usm-login" className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white px-6">
      <div className="w-full max-w-sm">
        <div className="mb-10 text-center">
          <p className="text-[10px] uppercase tracking-[0.5em] text-[#C8A96A] mb-3">Uzungöl Store Manager</p>
          <h1 className="font-heading text-3xl">USM</h1>
          <p className="text-xs text-[#71717A] mt-2 uppercase tracking-[0.2em]">Mağaza Yönetim Sistemi</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-[#A1A1AA] block mb-2">Kullanıcı Adı</label>
            <input
              data-testid="usm-login-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
              className="w-full px-4 py-3 bg-[#1a1a1a] border border-[#27272A] focus:border-[#C8A96A] outline-none text-sm"
            />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-[#A1A1AA] block mb-2">Şifre</label>
            <input
              data-testid="usm-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full px-4 py-3 bg-[#1a1a1a] border border-[#27272A] focus:border-[#C8A96A] outline-none text-sm"
            />
          </div>
          <button
            data-testid="usm-login-submit"
            type="submit"
            disabled={submitting}
            className="w-full bg-[#C8A96A] hover:bg-[#A6864A] disabled:opacity-50 text-white text-xs uppercase tracking-[0.25em] px-6 py-4 transition-colors inline-flex items-center justify-center gap-3"
          >
            <LogIn size={14} /> {submitting ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
        <p className="text-[10px] text-[#52525B] text-center mt-10 uppercase tracking-[0.2em]">İç sistem • Yetkisiz erişim yasaktır</p>
      </div>
    </div>
  );
}
